import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import GifVideosSection from '../components/GifVideosSection';
import AboutSection from '../components/AboutSection.js';
import HowItWorksSection from '../components/HowItWorksSection.js';
import RecommendationsSection from '../components/RecommendationsSection.js';
import ProgramsSection from '../components/ProgramsSection.js';
import MinisSection from '../components/MinisSection.js';
import BrandingsSection from '../components/BrandingsSection.js';
import ButtonsSection from '../components/ButtonsSection.js';
import './home.css';
import Footer from '../components/Footer.js';
import '../sectionAnimations.css';
import HorizontalScroller from '../components/HorizontalScroller';
import AuthModal from '../components/AuthModal.js';

const Home = () => {
  const location = useLocation();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [isFooterInView, setIsFooterInView] = useState(false);

  useEffect(() => {
    if (location.state?.scrollToContact) {
      setTimeout(() => {
        const footer = document.getElementById('contact-footer');
        if (footer) {
          const rect = footer.getBoundingClientRect();
          const offset = rect.bottom - window.innerHeight;
          window.scrollBy({ top: offset, behavior: 'smooth' });
        }
      }, 100);
    } else if (window.location.hash) {
      const el = document.getElementById(window.location.hash.replace('#', ''));
      if (el) {
        const rect = el.getBoundingClientRect();
        const offset = rect.bottom - window.innerHeight;
        window.scrollBy({ top: offset, behavior: 'smooth' });
      }
    }
  }, [location]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsFooterInView(entry.isIntersecting),
      { threshold: 0.3 }
    );
    const footer = document.getElementById('contact-footer');
    if (footer) observer.observe(footer);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isFooterInView) {
      window.dispatchEvent(new CustomEvent('footer-in-view'));
    } else {
      window.dispatchEvent(new CustomEvent('footer-out-view'));
    }
  }, [isFooterInView]);
  
  return (
    <>
      {showAuthModal && <AuthModal onClose={() => setShowAuthModal(false)} />}
      <GifVideosSection />
      <AboutSection />
      <HowItWorksSection />
      <RecommendationsSection />
      <HorizontalScroller>
        <ProgramsSection />
      </HorizontalScroller>
      <HorizontalScroller>
        <MinisSection />
      </HorizontalScroller>
      <HorizontalScroller>
        <BrandingsSection />
      </HorizontalScroller>
      <ButtonsSection />
    </>
  );
};

export default Home;
